import { render, staticRenderFns } from "./rechargeOrder.vue?vue&type=template&id=52907a4b&scoped=true&"
import script from "./rechargeOrder.vue?vue&type=script&lang=js&"
export * from "./rechargeOrder.vue?vue&type=script&lang=js&"
import style0 from "./rechargeOrder.vue?vue&type=style&index=0&id=52907a4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52907a4b",
  null
  
)

export default component.exports